import { render, staticRenderFns } from "./RouteView.vue?vue&type=template&id=5ec90b3d&scoped=true&"
import script from "./RouteView.vue?vue&type=script&lang=js&"
export * from "./RouteView.vue?vue&type=script&lang=js&"
import style0 from "./RouteView.vue?vue&type=style&index=0&id=5ec90b3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec90b3d",
  null
  
)

export default component.exports